import React, { Component } from 'react';
import { post } from '../utils/request';
import queryString from 'query-string';
import { wxShare, isWeChat, deleteUrlKey } from '../utils/util';

// component
import Banner from '../components/banner';
import Login from '../components/login';
import Intro from '../components/intro';
import TopDom from '../components/top';
import Dialog from '../components/dialog';
import AttService from '../components/attentionService';
import { UserInfoMedia } from '../components/groupPerson';
import { ProjectInfoMedia } from '../components/groupProject';
import { OtherInfo } from '../components/groupOther';

class Class extends Component {
  constructor (props) {
    super(props);
    // 报名表信息
    this.state = {
      checkErr: false, // 检测表单数据
      hasLogin: false, // 默认没登录的情况下不会出现表单
      currentPageInfo: {}, // 页面基础信息
      endGetPage: false, // 页面基本信息获取完毕
      endGetUserInfo: false, // 页面表单信息获取完毕
      userInfo: {}, // 用户基本信息和项目信息
      showServiceDialog: false,// 展示服务号关注二维码
      wechatDialogJson: {}, // 服务号传送json
      commitFlag: true
    }
    
    // login组件信息
    this.loginInfo = {
      urlValues: '',
      userLoginInfo: {}
    };

    // 其他问题组件
    this.resApplyData = {
      answers: []
    };
  }
  componentDidMount () {
    const urlValues = queryString.parse(this.props.location.search);
    this.pageUrlValues = urlValues;
    this.loginInfo.urlValues = urlValues; // 传值给login组件
    this.getPageInfo();
  }
  getPageInfo = () => {
    post('/fancube/apply/apply_info/', {
      "code": this.pageUrlValues.acid
    })
    .then(res => {
      if (res.code === 200) {
        // set title
        if (res.data.apply_title) {
          document.title = res.data.apply_title
        }
        wxShare(res.data.apply_title, '小饭桌是一家聚焦商业与科技创新，关注创业者和企业家命运的新型媒体');
        // storage
        localStorage.removeItem('formPageSto');
        localStorage.setItem('formPageSto', JSON.stringify({
          banner: 'https://static-image.xfz.cn/xfz-report-banner.jpg',
          from: 'media',
          title: res.data.apply_title,
          shareUrl: deleteUrlKey('code')
        }))
        // change state
        this.setState({
          currentPageInfo: res.data,
          endGetPage: 'end'
        })
      }
    })
  }
  getUserInfo = (phone) => {
    post('/fancube/apply/v2/report/en/', {
      "code": this.pageUrlValues.acid,
      "phone": phone
    })
    .then(res => {
      if (res.code === 200) {
        if (res.data.apply) {
          this.state.currentPageInfo["answers"] = res.data.apply.answers;
        }
        this.setState({
          userInfo: res.data,
          currentPageInfo: this.state.currentPageInfo,
          endGetUserInfo: 'end'
        })
      }
    })
  }
  getUserData = (resPonUserData) => {
    this.setState({
      resPonUserData
    })
  }
  getProjectData = (resProjectData) => {
    this.setState({
      resProjectData
    })
  }
  getApplyData = (resApplyData) => {
    this.resApplyData = resApplyData;
  }
  getLoginData = (resLoginData) => {
    this.resLoginData = resLoginData;
    this.setState({
      hasLogin: resLoginData.hasLogin,
      openId: resLoginData.openid
    },() => {
      if (this.state.hasLogin) {
        // 登录成功后获取页面个人信息
        this.getUserInfo(resLoginData.userLoginInfo.phone);
        // 传参给服务号二维码组件
        let wechatDialogJson = {
          'code': this.pageUrlValues.acid
        }
        if (isWeChat() && this.state.openId ) {
          wechatDialogJson['openid'] = this.state.openId;
        }
        this.setState({
          wechatDialogJson: wechatDialogJson
        })
      }
    })
  }
  getAttService = (resAttService) => {
    this.setState({
      subscribe: resAttService.subscribe
    })
  }
  ajaxSubmitData = () => {
    if (this.state.resPonUserData.isRight && this.state.resProjectData.isRight && this.state.commitFlag) {
      this.setState({
        commitFlag: false
      })
      post('/fancube/apply/v2/report/submit/', {
        "project": this.state.resProjectData,
        "entrepreneur": this.state.resPonUserData,
        "apply": {
          "answers": this.resApplyData.answers,
          "code": this.pageUrlValues.acid,
          "channel": ""
        },
        "uid": this.resLoginData.userLoginInfo.uid
      }).then(res => {
        this.setState({
          commitFlag: true
        })
        if (res.code === 200) {
          // 没有关注服务号的情况
          if (!!!this.state.subscribe) {
            this.setState({
              showServiceDialog: true
            })
          }
          // 已经关注服务号
          else {
            const { history } = this.props;
            const location = {
              pathname: '/success'
            }
            history.push(location);
          }
        }
      })
    }
  }
  handleSubmit = () => {
    this.setState({
      checkErr: true
    })
    this.ajaxSubmitData();
  }
  render () {
    return (
      <div className="media-wrapper page-wrapper">
        {
          this.state.endGetPage &&
          <div className="end-wrapper">
            <TopDom />
            <Banner url={'https://static-image.xfz.cn/xfz-report-banner.jpg'} />
            {false && <div>
              <Intro {...this.state.currentPageInfo} isShowValue={this.pageUrlValues} notShow={true} />
              <Login {...this.loginInfo} type={this.state.currentPageInfo.type} receiveData={this.getLoginData} />
              {
                this.state.hasLogin && this.state.endGetUserInfo &&
                <div className="form-info-wrapper">
                  <div className="form-title">登记报道信息</div>
                  <ProjectInfoMedia { ... this.state.userInfo.project } checkErr={ this.state.checkErr } receiveData={ this.getProjectData } />
                  <UserInfoMedia { ...this.state.userInfo.entrepreneur } checkErr={ this.state.checkErr } receiveData={ this.getUserData } />
                  {
                    this.state.currentPageInfo && this.state.currentPageInfo.questions && this.state.currentPageInfo.questions.length > 0 && 
                    <OtherInfo { ... this.state.currentPageInfo } receiveData={ this.getApplyData } />
                  }
                  <Dialog isShow={ this.state.showServiceDialog }>
                    <AttService receiveData={ this.getAttService } isShowDia={ this.state.showServiceDialog } history={ this.props.history } { ...this.state.wechatDialogJson } />
                  </Dialog>
                  { this.state.checkErr && (!this.state.resPonUserData.isRight || !this.state.resProjectData.isRight) && <p className="err-bottom-tips">请完善相关资料</p>}
                  <div className={this.state.commitFlag ? "submit-form l-button" : "submit-form l-button disabled"} onClick={ this.handleSubmit }>{this.state.commitFlag ? '立即报名' : '正在提交...'}</div>
                </div>
              }
            </div>
            }


            <div className='static-report'>
              <h3>寻求报道</h3>
              <p className='text-aleft'>小饭桌新媒体拥有30万+高净值粉丝，已形成行业专家群、优秀CEO群、读者群等 私域社群400个，覆盖一线投资机构投资人和创业者超10万人，内容全网曝光量累计 1亿+，超过 2000+ 企业通过小饭桌创服媒体的报道成功获得融资，是创投圈最具影响力的新媒体之一。</p>
              <p className='text-aleft'>在小饭桌新媒体的背后，是成立于2014年的凡卓集团，其成立于2014年，本着“陪伴创业者从平凡到卓越”的愿望，以为创业者“找人、找钱、找产业政策”为使命，依托独有的创投生态体系，扎根产业实体。集团具体包含小饭桌创服（课程培训、媒体、沙龙活动等产品）、小饭桌创投（直投基金）、凡卓资本（财务顾问）三个板块，其中凡卓资本累计帮助近600家企业完成超800亿元融资，近两年内帮助数百个明星项目完成近300亿元融资。</p>
              <img src='https://static-image.xfz.cn/1693129963576/xfz_baodao.jpg' width="300px"></img>
            </div>
          </div>
        }
      </div>
    )
  }
}
export default Class;